import React from 'react';
import { StyledIconButton } from 'common/components/button/StyledButton';

type ExportThreadButtonProps = {
  threadId?: number;
  onExport: () => void;
  disabled?: boolean;
  title?: string;
};

const ExportThreadButton: React.FC<ExportThreadButtonProps> = ({
  threadId,
  onExport,
  disabled = false,
  title = 'Download conversation',
}) => {
  const isDisabled = disabled || threadId === undefined || threadId === null;

  return (
    <StyledIconButton
      icon="download"
      title={title}
      disabled={isDisabled}
      onClick={() => {
        if (!isDisabled) {
          onExport();
        }
      }}
    />
  );
};

export default ExportThreadButton;
